"use client";

export default function GlobalError({ reset }: { reset: () => void }) {
    return (
        <html lang="es">
            <body className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-6">
                <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full text-center">
                    <div className="bg-red-100 text-red-500 p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
                        </svg>
                    </div>
                    <h2 className="text-xl font-bold text-gray-800 mb-2">Error crítico</h2>
                    <p className="text-sm text-gray-600 mb-6">
                        La aplicación encontró un error inesperado. Por favor intente nuevamente.
                    </p>
                    <button
                        onClick={() => reset()}
                        className="bg-blue-cole text-white px-6 py-2 rounded-lg font-semibold hover:opacity-90 transition-opacity"
                    >
                        Recargar
                    </button>
                </div>
            </body>
        </html>
    );
}
